export default {
  editRowCol: {
    width: '40px',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
  },
  row: ({ editable }) => ({
    padding: '5px',
    marginBottom: '5px',
    background: editable ? '#DBD6E5' : '#fff',
    '&:hover': {
      boxShadow: '1px 3px 6px rgba(0, 0, 0, 0.05)',
    },
  }),
  rowContent: {
    display: 'flex',
    color: '#4E4C4C',
    minHeight: '60px',
    position: 'relative',
    '&:hover': {
      '& .edit-icon': {
        display: 'flex',
      },
    },
  },
  rowButtonsContainer: {
    display: 'flex',
    padding: '10px 20px',
    justifyContent: 'space-between',
  },
  rowActionBtn: {
    textTransform: 'none',
  },
  deleteRowIcon: {
    fontSize: 16,
    marginLeft: 4,
    display: 'flex',
    color: '#878787',
    cursor: 'pointer',
  },
  saveBtnDisabled: {
    opacity: '0.5',
  },
  arrow: {
    borderRadius: '5px',
    height: 'fit-content',
    position: 'relative',
    float: 'left',
    '&::before': {
      content: 'close-quote',
      position: 'absolute',
      right: '-15px',
      top: '15px',
      borderTop: '10px solid transparent',
      borderRight: 'none',
      borderLeft: '8px solid #BAB9DB',
      borderBottom: '10px solid transparent',
    },
  },
  macroBlock: {
    width: '-webkit-fill-available',
    height: '-webkit-fill-available',
    borderRadius: '5px',
    background: '#ffff',
    padding: '5px',
  },
  nodeCol: {
    width: '25%',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'flex-start',
  },
  triggersCol: {
    width: '25%',
    flexShrink: 0,
    display: 'flex',
    paddingRight: '20px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  funcCol: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  noHoverOrFocus: {
    '&:hover, &:focus': {
      outline: 'none !important',
      background: '#e8ebf5',
    }
  },
  textArea: {
    width: '100%',
    height: '100%',
    minHeight: 24,
    flexShrink: 0,
    maxHeight: '900px',
    cursor: 'text',
    border: 'none',
    display: 'flex',
    color: '#4E4C4C',
    resize: 'vertical',
    background: '#e8ebf5',
    boxSizing: 'border-box',
    '&:hover, &:focus': {
      outline: '1px solid #168CCE',
      background: 'rgba(168, 183, 227, 0.45)',
    },
  },
  trigger: {
    marginRight: '10px',
    fontSize: '12px',
    color: '#4E4C4C',
  },
  removeTriggerEventIcon: {
    fontSize: 16,
    color: '#878787',
    marginRight: 10,
    cursor: 'pointer',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
  triggerEditContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 9,
  },
  addTriggerBtn: {
    width: 'max-content',
    textTransform: 'none',
  },
  addTriggerBtnIcon: {
    fontSize: 15,
  },
  predCol: {
    marginRight: '20px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'flex-start',
  },
  eventsCol: {
    width: '36%',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  subscriptionCol: {
    width: '30%',
    flexShrink: 0,
    display: 'flex',
    paddingRight: '20px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  subId: {
    marginRight: 26,
  },
  //time period
  staticCol: {
    width: '100px',
    flexShrink: 0,
    flexGrow: 0,
    display: 'flex',
    alignItems: 'flex-start',
    paddingRight: '10px',
  },
  titleCol: {
    width: '300px',
    display: 'flex',
    alignItems: 'flex-start',
    paddingRight: '10px',
  },
  functionCol: {
    flexBasis: '100px',
    flexShrink: 0,
    flexGrow: 1,
    display: 'flex',
    alignItems: 'flex-start',
    paddingRight: '14px',
  },
  eventsSelect: {
    width: '-webkit-fill-available',
    padding: '0 5px !important',
    minHeight: '19px',
    maxHeight: '24px',
    minWidth: '30px',
  },
  textFieldInput: {
    width: '100%',
    flexShrink: 1,
    border: 'none',
    display: 'flex',
    cursor: 'text',
    padding: '0 5px !important',
    color: '#4E4C4C',
    minHeight: '24px',
    background: '#e8ebf5',
    '&:hover, &:focus': {
      outline: '1px solid #168CCE',
      background: 'rgba(168, 183, 227, 0.45)',
    },
  },
  blackCheckbox: {
    '& .Mui-checked': {
      color: '#222029',
    },
  },
  container: {
    height: 34,
    fontSize: 13,
    opacity: 0.8,
    display: 'flex',
    color: '#168CCE',
    paddingLeft: '30px',
    cursor: 'pointer',
    background: '#fff',
    alignItems: 'center',
    textTransform: 'capitalize',
    '&:hover': {
      opacity: 1,
    },
  },
  icon: {
    fontSize: 17,
    marginRight: 4,
    color: '#168CCE',
  },
  firstTd: {
    padding: '10px 0 10px 50px',
  },
  lastTd: {
    padding: '10px 50px 10px 0px',
  },
  middleTd: {
    padding: 10,
  },
  //events tabs
  headingContainer: {
    display: 'flex',
    '& div': {
      boxSizing: 'border-box',
    },
  },
  individsIdsCol: {
    flexShrink: '0',
    padding: '10px 10px 10px 10px',
  },
  individsConceptCol: {
    width: '20%',
    padding: '10px 10px 10px 10px',
  },
  individsScriptCol: {
    padding: '10px 0px 0px 0px',
  },
  individsEventCol: {
    width: '30%',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
  },
  predIdsCol: {
    flexShrink: '0',
    padding: '10px 10px 10px 10px',
  },
  predSubsCol: {
    width: '20%',
    flexShrink: '0',
    padding: '10px 0 10px 48px',
  },
  predEventCell: {
    width: '80px',
    display: 'flex',
    paddingLeft: 6,
    flexShrink: '0',
    alignItems: 'center',
  },
  predSubCell: {
    width: '20%',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
  },
  predScriptCell: {
    display: 'flex',
    paddingLeft: '100px',
    alignItems: 'center',
  },
  firsTimePeriodheadingContainer: {
    display: 'flex',
  },
  firsTimePeriodCol: {
    minWidth: '60px',
    flexShrink: 0,
    flexGrow: 0,
    display: 'flex',
    alignItems: 'flex-start',
    padding: '10px 0 10px 40px',
  },
  periodIdsCol: {
    flexShrink: '0',
    padding: '10px 10px 10px 10px',
  },
  titlePeriodCol: {
    flexBasis: '100px',
    flexShrink: 0,
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0 10px 0px',
  },
  functionPeriodCol: {
    flexBasis: '100px',
    flexShrink: 0,
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    paddingRight: '14px',
    padding: '10px 0 10px 20px',
  },
  editPeriodCol: {
    minWidth: '20px',
    flexShrink: 0,
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0 10px 20px',
  },
  staticTimePeriodCol: {
    width: '100px',
    flexShrink: 0,
    flexGrow: 0,
    display: 'flex',
    alignItems: 'flex-start',
    padding: '10px 0 10px 20px',
  },
  //events page
  mainContainer: {
    padding: '0px 30px',
  },
  filterContainer: {
    background: '#fff',
    padding: '20px 30px 10px 30px',
  },
  loaderContainer: {
    paddingTop: 50,
    display: 'flex',
    justifyContent: 'center',
  },
};
